module.exports = {
	"articleTitle1": "Afternoon Delight draws in customers with consistent breakfast ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Afternoon Delight",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/multimedia/video-afternoon-delight",
	"articleSnippet1": "Mar 24, 2016 ... For the past 38 years, Afternoon Delight has sat on the corner of East Liberty \nStreet and South Fifth Avenue serving homemade specials to the ...",
	"articleSnippet2": "Dec 2, 2015 ... A short talk with the owner of Afternoon Delight in Ann Arbor, Michigan. ... An \nAfternoon Delight cook shows us how to make the Meat Boule, ...",
	"foodRecommendations": [
		{
			"text": "Awesome breakfast place.",
			"person": "Charlie Ruiz"
		}
	],
	"articleTitle2": "VIDEO: Afternoon Delight ",
	"address": "251 E Liberty St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160327/ara.afternoondelight.jpg?itok=J26LJQuO",
			"author": "Amanda Allen",
			"caption": "Afternoon Delight serves homemade foods at its location on the corner of East Liberty Street and South Fifth Avenue."
		}
	],
	"position": {
		"lat": 42.279636,
		"lng": -83.746306
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/afternoondelight.json
// module id = 801
// module chunks = 0